// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/common/components/ScrollableBox.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

const bem = bemify('scrollable-box');

type ScrollableBoxProps = {
  children: Node,
  className?: string,
  kind?: KindType,
  maxHeight?: number | string,
};

const ScrollableBox = (props: ScrollableBoxProps) => {
  const className = bem(toModifiers(props.kind), props.className);
  const style = { maxHeight: props.maxHeight };
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  );
};

export default ScrollableBox;
